import { FC } from 'react';

type Props = {
	className?: string;
};

const Mail_02_IconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#2B2B2B'
			stroke='none'
			className={className}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12.1747 3.14263C10.721 3.1061 9.28156 3.1061 7.82792 3.14263L7.78462 3.14371C6.64969 3.17221 5.73644 3.19514 5.00454 3.3226C4.23828 3.45605 3.6155 3.712 3.08938 4.24012C2.56546 4.76604 2.31085 5.37986 2.17994 6.1337C2.05529 6.85149 2.03631 7.74244 2.01279 8.84613L2.01186 8.88989C1.99605 9.63144 1.99605 10.3687 2.01186 11.1103L2.01279 11.154C2.03631 12.2577 2.05529 13.1487 2.17994 13.8665C2.31085 14.6203 2.56546 15.2341 3.08938 15.76C3.6155 16.2882 4.23828 16.5441 5.00454 16.6776C5.73643 16.805 6.64966 16.8279 7.78458 16.8564L7.82792 16.8576C9.28156 16.894 10.721 16.894 12.1747 16.8576L12.218 16.8564C13.3529 16.8279 14.2662 16.805 14.9981 16.6776C15.7643 16.5441 16.3871 16.2882 16.9132 15.76C17.4372 15.2341 17.6918 14.6203 17.8226 13.8665C17.9473 13.1487 17.9663 12.2577 17.9898 11.154L17.9908 11.1103C18.0065 10.3687 18.0065 9.63144 17.9908 8.88989L17.9898 8.84613C17.9663 7.74246 17.9473 6.8515 17.8226 6.13371C17.6918 5.37987 17.4372 4.76605 16.9132 4.24014C16.3871 3.71201 15.7643 3.45606 14.9981 3.32261C14.2662 3.19514 13.3529 3.17221 12.218 3.14372L12.1747 3.14263ZM6.56396 6.91457C6.29857 6.75766 5.95624 6.8456 5.79933 7.11098C5.64242 7.37637 5.73036 7.71871 5.99574 7.87562L8.18551 9.17027C8.83371 9.55352 9.39298 9.8141 10.0014 9.8141C10.6098 9.8141 11.1691 9.55352 11.8173 9.17027L14.007 7.87562C14.2724 7.71871 14.3603 7.37637 14.2034 7.11098C14.0465 6.8456 13.7042 6.75766 13.4388 6.91457L11.2491 8.20924C10.6206 8.58078 10.2864 8.69764 10.0014 8.69764C9.71631 8.69764 9.38219 8.58078 8.75369 8.20924L6.56396 6.91457Z'
				fill='inherit'
			/>
		</svg>
	);
};

export default Mail_02_IconSolid;
